module.exports = __webpack_public_path__ + "da11b043ada6300f157dd6ea6a27fdd4.svg";